export enum AutomationFootprintVersionStatus {
    Draft = 'Draft',
    Released = 'Released',
    Obsolete = 'Obsolete',
}
